(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const backdrop = document.querySelector('[data-cart-backdrop]');
  const filled = drawer.querySelector('[data-cart-filled]');
  const empty = drawer.querySelector('[data-cart-empty]');
  const items = drawer.querySelector('[data-cart-items]');
  const checkout = drawer.querySelector('[data-cart-checkout]');
  const recentSection = drawer.querySelector('[data-cart-recent]');
  const recentList = drawer.querySelector('[data-recent-list]');
  const count = drawer.querySelector('[data-drawer-count]');
  const previousCartLink = document.querySelector('.cart-toast a');
  let returnFocus = null;
  let previousOverflow = '';
  let busy = false;
  let closeTimer = 0;

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.storeCurrency || 'USD'
  }).format(cents / 100);

  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const updateCounts = cart => {
    count.textContent = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(element => {
      element.textContent = cart.item_count;
    });
  };

  const optionRows = item => {
    const rows = [];
    (item.options_with_values || []).forEach(option => {
      if (!option.value || option.value === 'Default Title') return;
      const label = /color/i.test(option.name) ? 'Color' : /title|option/i.test(option.name) ? 'Select Option' : option.name;
      rows.push(`${label}: ${option.value}`);
    });
    Object.entries(item.properties || {}).forEach(([key, value]) => {
      if (!value || key.startsWith('_') || rows.some(row => row.endsWith(`: ${value}`))) return;
      rows.push(`${key}: ${value}`);
    });
    if (!rows.length && item.variant_title && item.variant_title !== 'Default Title') rows.push(`Select Option: ${item.variant_title}`);
    return rows;
  };

  const renderLine = item => {
    const article = node('article', 'cart-drawer__line');
    const imageLink = node('a', 'cart-drawer__image');
    imageLink.href = item.url;
    if (item.image) {
      const image = node('img');
      image.src = item.image;
      image.alt = item.product_title;
      image.loading = 'lazy';
      imageLink.append(image);
    }
    const details = node('div', 'cart-drawer__details');
    const title = node('a', 'cart-drawer__title', item.product_title);
    title.href = item.url;
    details.append(title);
    optionRows(item).forEach(row => details.append(node('p', 'cart-drawer__option', row)));
    details.append(node('strong', 'cart-drawer__price', money(item.final_price)));

    const controls = node('div', 'cart-drawer__controls');
    const quantity = node('div', 'cart-drawer__quantity');
    const minus = node('button', '', '−');
    minus.type = 'button';
    minus.setAttribute('aria-label', `Decrease quantity of ${item.product_title}`);
    minus.dataset.cartQuantity = '-1';
    const value = node('span', '', item.quantity);
    const plus = node('button', '', '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', `Increase quantity of ${item.product_title}`);
    plus.dataset.cartQuantity = '1';
    quantity.append(minus, value, plus);
    const remove = node('button', 'cart-drawer__remove');
    remove.type = 'button';
    remove.setAttribute('aria-label', `Remove ${item.product_title} from cart`);
    remove.dataset.cartRemove = '';
    remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m3 3v7m6-7v7"/></svg>';
    controls.append(quantity, remove);
    article.append(imageLink, details, controls);
    article.dataset.lineKey = item.key;
    return article;
  };

  const getRecentlyViewed = () => JSON.parse(sessionStorage.getItem('jackery-recently-viewed') || '[]');

  const recordProduct = product => {
    if (!product?.id || !product.variantId) return;
    const products = getRecentlyViewed().filter(item => item.id !== product.id);
    products.unshift(product);
    sessionStorage.setItem('jackery-recently-viewed', JSON.stringify(products.slice(0, 8)));
  };

  const renderRecentlyViewed = () => {
    const products = getRecentlyViewed();
    recentList.replaceChildren();
    recentSection.hidden = !products.length;
    products.forEach(product => {
      const card = node('article', 'cart-recent__card');
      const image = node('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      const imageLink = node('a', 'cart-recent__image');
      imageLink.href = product.url;
      imageLink.append(image);
      const info = node('div', 'cart-recent__info');
      const title = node('a', 'cart-recent__title', product.title);
      title.href = product.url;
      info.append(title);
      if (product.variantTitle && product.variantTitle !== 'Default Title') info.append(node('p', 'cart-recent__variant', product.variantTitle));
      const priceRow = node('div', 'cart-recent__price');
      priceRow.append(node('strong', '', money(product.price)));
      if (product.compareAtPrice > product.price) {
        priceRow.append(node('s', '', money(product.compareAtPrice)));
        priceRow.append(node('span', '', `${Math.round((1 - product.price / product.compareAtPrice) * 100)}% OFF`));
      }
      info.append(priceRow);
      const add = node('button', '', 'Add to cart');
      add.type = 'button';
      add.className = 'cart-recent__add';
      add.dataset.recentAdd = product.variantId;
      add.disabled = product.available === false;
      info.append(add);
      card.append(imageLink, info);
      recentList.append(card);
    });
  };

  const render = cart => {
    drawer.querySelector('[data-cart-error]').textContent = '';
    updateCounts(cart);
    const hasItems = cart.item_count > 0;
    filled.hidden = !hasItems;
    empty.hidden = hasItems;
    checkout.hidden = !hasItems;
    drawer.classList.toggle('has-items', hasItems);
    if (hasItems) {
      items.replaceChildren(...cart.items.map(renderLine));
      drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    } else {
      renderRecentlyViewed();
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.storeRoot || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load your cart. Please try again.');
    return response.json();
  };

  const refresh = async () => render(await fetchCart());

  const open = async trigger => {
    window.clearTimeout(closeTimer);
    returnFocus = trigger || document.activeElement;
    previousOverflow = document.body.style.overflow;
    backdrop.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(() => { backdrop.classList.add('is-open'); drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]').focus();
    await refresh();
  };

  const close = () => {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    closeTimer = window.setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 260);
    document.body.style.overflow = previousOverflow;
    returnFocus?.focus();
  };

  const change = async (key, quantity) => {
    if (busy) return;
    busy = true;
    drawer.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.storeRoot || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Unable to update your cart.');
      render(cart);
    } finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
    }
  };

  const add = async formData => {
    if (busy) return false;
    busy = true;
    drawer.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.storeRoot || '/'}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      const cart = await fetchCart();
      render(cart);
    } finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
    }
    await open(document.activeElement);
    return true;
  };

  document.querySelectorAll('[data-cart-drawer-open]').forEach(trigger => trigger.addEventListener('click', event => {
    event.preventDefault();
    open(trigger).catch(() => { window.location.href = trigger.href; });
  }));
  drawer.querySelector('[data-cart-close]').addEventListener('click', close);
  drawer.querySelector('[data-continue-shopping]').addEventListener('click', close);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });
  drawer.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-quantity], [data-cart-remove], [data-recent-add], [data-benefits-toggle]');
    if (!button || busy) return;
    if (button.hasAttribute('data-benefits-toggle')) {
      const benefits = button.closest('.cart-benefits');
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.setAttribute('aria-label', expanded ? 'Show benefit details' : 'Hide benefit details');
      benefits.querySelector('[data-benefits-details]').hidden = expanded;
      return;
    }
    if (button.hasAttribute('data-recent-add')) {
      const formData = new FormData();
      formData.set('id', button.dataset.recentAdd);
      formData.set('quantity', '1');
      add(formData).catch(error => { drawer.querySelector('[data-cart-error]').textContent = error.message; });
      return;
    }
    const line = button.closest('[data-line-key]');
    if (!line) return;
    const quantity = button.hasAttribute('data-cart-remove')
      ? 0
      : Number(line.querySelector('.cart-drawer__quantity span').textContent) + Number(button.dataset.cartQuantity);
    change(line.dataset.lineKey, quantity).catch(async error => {
      drawer.querySelector('[data-cart-error]').textContent = error.message;
      await refresh();
      busy = false;
      drawer.removeAttribute('aria-busy');
    });
  });

  document.querySelectorAll('[data-add-form]').forEach(form => form.addEventListener('submit', event => {
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button.disabled = true;
    drawer.querySelector('[data-cart-error]').textContent = '';
    add(new FormData(form)).catch(error => {
      const message = form.querySelector('[data-form-message]');
      if (message) message.textContent = error.message;
      else drawer.querySelector('[data-cart-error]').textContent = error.message;
    }).finally(() => { button.disabled = false; });
  }));

  const recentProduct = document.querySelector('[data-recent-product]');
  if (recentProduct) recordProduct(JSON.parse(recentProduct.textContent));
  previousCartLink?.addEventListener('click', event => {
    event.preventDefault();
    open(previousCartLink).catch(() => { window.location.href = previousCartLink.href; });
  });
  refresh().catch(() => {});
  window.cartDrawer = { add, close, open, refresh, recordProduct };
})();
